module.exports = "/cyber/_next/static/images/replenish-steam-bg-tablet-0bba069a67be330a6af45c966d513f2a.jpg";